<template>
  <section class='section'>
    <h1 class="title has-text-centered">Configuración de datos manuales</h1>
    <br><br>
    <h2 class="title has-text-dark">Frases</h2>
    <div class='container'>
      <div class="box">
        <div class="columns">
          <div class="column"><h1 class="title">Es</h1></div>
          <div class="column">
            <div class="field">
              <label class="label">Clan</label>
              <div class="control">
                <input
                    v-model="manuales.clanes"
                    class="input"
                    type="text"
                    placeholder='Clan'
                    name='m-clanes'
                    @keypress='sum'
                    min='0'
                    max='0'
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">Adhocratica</label>
              <div class="control">
                <input
                    v-model="manuales.adhocraticaes"
                    class="input"
                    type="text"
                    placeholder="Adhocratica"
                    name='m-adhocraticaes'
                    @keypress='sum'
                    min='0'
                    max='0'
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">Jerárquica</label>
              <div class="control">
                <input
                    v-model="manuales.jerarquicaes"
                    class="input"
                    type="text"
                    placeholder="Jerárquica"
                    name='m-jerarquicaes'
                    @keypress='sum'
                    min='0'
                    max='0'
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">Mercado</label>
              <div class="control">
                <input
                    v-model="manuales.mercadoes"
                    class="input"
                    type="text"
                    placeholder="Mercado"
                    name='m-mercadoes'
                    @keypress='sum'
                    min='0'
                    max='0'
                />
              </div>
            </div>
          </div>
        </div>
        <hr/>
        <div class="columns">
          <div class="column"><h1 class="title">Debería ser</h1></div>
          <div class="column">
            <div class="field">
              <label class="label">Clan</label>
              <div class="control">
                <input
                    v-model="manuales.clands"
                    class="input"
                    type="text"
                    placeholder="Clan"
                    name='m-clands'
                    @keypress='sum'
                    min='0'
                    max='0'
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">Adhocratica</label>
              <div class="control">
                <input
                    v-model="manuales.adhocraticads"
                    class="input"
                    type="text"
                    placeholder="Adhocratica"
                    name='m-adhocraticads'
                    @keypress='sum'
                    min='0'
                    max='0'
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">Jerárquica</label>
              <div class="control">
                <input
                    v-model="manuales.jerarquicads"
                    class="input"
                    type="text"
                    placeholder="Jerárquica"
                    name='m-jerarquicads'
                    @keypress='sum'
                    min='0'
                    max='0'
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">Mercado</label>
              <div class="control">
                <input
                    v-model="manuales.mercadods"
                    class="input"
                    type="text"
                    placeholder="Mercado"
                    name='m-mercadods'
                    @keypress='sum'
                    min='0'
                    max='0'
                />
              </div>
            </div>
          </div>
        </div>
        <button class="button is-dark" @click="savedatamanual">Guardar</button>
        <button class="button is-light" @click="canceldatamanual">
          Cancelar
        </button>
      </div>
    </div>

    <br><br>
    <h2 class="title has-text-dark">Entrevistas</h2>
    <div class='container'>
      <div class="box">
        <div class="columns">
          <div class="column"><h1 class="title">Es</h1></div>
          <div class="column">
            <div class="field">
              <label class="label">Clan</label>
              <div class="control">
                <input
                    v-model="manualesEn.clanes"
                    class="input"
                    type="text"
                    placeholder="Clan"
                    name='me-clanes'
                    @keypress='sum'
                    min='0'
                    max='0'
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">Adhocratica</label>
              <div class="control">
                <input
                    v-model="manualesEn.adhocraticaes"
                    class="input"
                    type="text"
                    placeholder="Adhocratica"
                    name='me-adhocraticaes'
                    @keypress='sum'
                    min='0'
                    max='0'
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">Jerárquica</label>
              <div class="control">
                <input
                    v-model="manualesEn.jerarquicaes"
                    class="input"
                    type="text"
                    placeholder="Jerárquica"
                    name='me-jerarquicaes'
                    @keypress='sum'
                    min='0'
                    max='0'
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">Mercado</label>
              <div class="control">
                <input
                    v-model="manualesEn.mercadoes"
                    class="input"
                    type="text"
                    placeholder="Mercado"
                    name='me-mercadoes'
                    @keypress='sum'
                    min='0'
                    max='0'
                />
              </div>
            </div>
          </div>
        </div>
        <hr/>
        <div class="columns">
          <div class="column"><h1 class="title">Es <span class='is-size-5 has-text-grey'>(Gerencia)</span></h1></div>
          <div class="column">
            <div class="field">
              <label class="label">Clan</label>
              <div class="control">
                <input
                    v-model="manualesEn.clanesg"
                    class="input"
                    type="text"
                    placeholder="Clan"
                    name='me-clanesg'
                    @keypress='sum'
                    min='0'
                    max='0'
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">Adhocratica</label>
              <div class="control">
                <input
                    v-model="manualesEn.adhocraticaesg"
                    class="input"
                    type="text"
                    placeholder="Adhocratica"
                    name='me-adhocraticaesg'
                    @keypress='sum'
                    min='0'
                    max='0'
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">Jerárquica</label>
              <div class="control">
                <input
                    v-model="manualesEn.jerarquicaesg"
                    class="input"
                    type="text"
                    placeholder="Jerárquica"
                    name='me-jerarquicaesg'
                    @keypress='sum'
                    min='0'
                    max='0'
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">Mercado</label>
              <div class="control">
                <input
                    v-model="manualesEn.mercadoesg"
                    class="input"
                    type="text"
                    placeholder="Mercado"
                    name='me-mercadoesg'
                    @keypress='sum'
                    min='0'
                    max='0'
                />
              </div>
            </div>
          </div>
        </div>
        <hr/>
        <div class="columns">
          <div class="column"><h1 class="title">Debería ser</h1></div>
          <div class="column">
            <div class="field">
              <label class="label">Clan</label>
              <div class="control">
                <input
                    v-model="manualesEn.clands"
                    class="input"
                    type="text"
                    placeholder="Clan"
                    name='me-clands'
                    @keypress='sum'
                    min='0'
                    max='0'
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">Adhocratica</label>
              <div class="control">
                <input
                    v-model="manualesEn.adhocraticads"
                    class="input"
                    type="text"
                    placeholder="Adhocratica"
                    name='me-adhocraticads'
                    @keypress='sum'
                    min='0'
                    max='0'
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">Jerárquica</label>
              <div class="control">
                <input
                    v-model="manualesEn.jerarquicads"
                    class="input"
                    type="text"
                    placeholder="Jerárquica"
                    name='me-jerarquicads'
                    @keypress='sum'
                    min='0'
                    max='0'
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">Mercado</label>
              <div class="control">
                <input
                    v-model="manualesEn.mercadods"
                    class="input"
                    type="text"
                    placeholder="Mercado"
                    name='me-mercadods'
                    @keypress='sum'
                    min='0'
                    max='0'
                />
              </div>
            </div>
          </div>
        </div>
        <button class="button is-dark" @click="savedatamanualEn">Guardar</button>
        <button class="button is-light" @click="canceldatamanualEn">
          Cancelar
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import apiServices from "@/services/yungol-services";
export default {
  data(){
    return {
      manuales: {
        clanes: null,
        adhocraticaes: null,
        jerarquicaes: null,
        mercadoes: null,
        clands: null,
        adhocraticads: null,
        jerarquicads: null,
        mercadods: null,
      },
      manualesEn:{
        clanes: null,
        adhocraticaes: null,
        jerarquicaes: null,
        mercadoes: null,
        clanesg: null,
        adhocraticaesg: null,
        jerarquicaesg: null,
        mercadoesg: null,
        clands: null,
        adhocraticads: null,
        jerarquicads: null,
        mercadods: null
      },
      procesoMan: {}
    }
  },
  props: {
    proceso: {
      type: Object,
    },
  },
  methods:{
    async savedatamanual() {
      let result;
      try {
        result =  await apiServices.post(`/datamanualcohortecultura`, {
          manuales: this.manuales,
          proceso: this.proceso._id,
        });
        await this.$store.dispatch("notify", {
          message: "Datos guardados.",
          position: "top-center",
          duration: 3000,
        });
        this.canceldatamanual();
        this.$emit("changeproceso", result.data);
      } catch (err) {
        console.log(err);
      }
    },
    async savedatamanualEn() {
      let result;
      try {
        result = await apiServices.post(`/datamanualEncohortecultura`, {
          manuales: this.manualesEn,
          proceso: this.proceso._id,
        });
        await this.$store.dispatch("notify", {
          message: "Datos guardados.",
          position: "top-center",
          duration: 3000,
        });
        this.canceldatamanualEn();
        this.$emit("changeproceso", result.data);
      } catch (err) {
        console.log(err);
      }
    },
    canceldatamanual() {
      this.manuales = {
        clanes: null,
        adhocraticaes: null,
        jerarquicaes: null,
        mercadoes: null,
        clands: null,
        adhocraticads: null,
        jerarquicads: null,
        mercadods: null,
      };
    },
    canceldatamanualEn() {
      this.manualesEn = {
        clanes: null,
        adhocraticaes: null,
        jerarquicaes: null,
        mercadoes: null,
        clands: null,
        adhocraticads: null,
        jerarquicads: null,
        mercadods: null,
      };
    },
    created(){
      Object.assign(this.procesoMan, this.proceso)
    },
    sum(el) {
      const _this = this

      let namev = el.target.name.split('-')[1]
      let type = el.target.name.split('-')[0]
      let data = type === 'm' ? _this.manuales : _this.manualesEn

      let es = {
        clanes: data['clanes'] ? data['clanes'] : "0",
        adhocraticaes: data['adhocraticaes'] ? data['adhocraticaes'] : "0",
        jerarquicaes: data['jerarquicaes'] ? data['jerarquicaes'] : "0",
        mercadoes: data['mercadoes'] ? data['mercadoes'] : "0"
      }
      let ds = {
        clands: data['clands'] ? data['clands']:"0",
        adhocraticads: data['adhocraticads'] ? data['adhocraticads'] : "0",
        jerarquicads: data['jerarquicads'] ? data['jerarquicads'] : "0",
        mercadods: data['mercadods'] ? data['mercadods'] : "0"
      }
      let esg = {
        clanesg: 0,
        adhocraticaesg: 0,
        jerarquicaesg: 0,
        mercadoesg: 0
      }

      if(type === 'me'){
        esg.clanesg = data.clanesg ? data.clanesg: "0"
        esg.adhocraticaesg = data.adhocraticaesg ? data.adhocraticaesg: "0"
        esg.jerarquicaesg = data.jerarquicaesg ? data.jerarquicaesg: "0"
        esg.mercadoesg = data.mercadoesg ? data.mercadoesg: "0"
      }

      if (el.charCode >= 48 && el.charCode <= 57){
        if (es[namev]){
          es[namev] =  parseFloat(es[namev] + el.key)
          let sum = Object.keys(es).reduce((sum,key)=>sum+parseFloat(es[key]||0),0);
          if (sum >100){
            el.preventDefault()
            this.$store.dispatch("notify", {
              message: `Supera los 100 puntos.`,
              type: "is-danger",
            });
          }
        }else if(ds[namev]){
          ds[namev] =  parseFloat(ds[namev] + el.key)
          let sum = Object.keys(ds).reduce((sum,key)=>sum+parseFloat(ds[key]||0),0);
          if (sum >100){
            el.preventDefault()
            this.$store.dispatch("notify", {
              message: `Supera los 100 puntos.`,
              type: "is-danger",
            });
          }
        }else if (esg[namev] && type === 'me'){
          esg[namev] =  parseFloat(esg[namev] + el.key)
          let sum = Object.keys(esg).reduce((sum,key)=>sum+parseFloat(esg[key]||0),0);
          if (sum >100){
            el.preventDefault()
            this.$store.dispatch("notify", {
              message: `Supera los 100 puntos.`,
              type: "is-danger",
            });
          }
        }
      }else {
        el.preventDefault()
        this.$store.dispatch("notify", {
          message: `Ingresa un número.`,
          type: "is-danger",
        });
      }
    }
  }
}
</script>

<style scoped lang='scss'>
.input {
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/components/cultura/Datoscultura.vue